
import ContactForm from '../components/ContactForm'
import IntSlides from '../components/IntSlides'
export default {
  auth: false,
  components: {
    ContactForm,
    IntSlides
  },
  data () {
    return {
      topSlides: [
        {
          title: '',
          img: 'slider2.jpg'
        },
        {
          title: '',
          img: 'slider.jpg'
        }
      ]
    }
  },
  head: {
    title: 'Contáctanos - Electrónica Poderosa',
    meta: [
      { hid: 'description', name: 'description', content: 'Electrónica Poderosa Informacion de contacto' }
    ]
  }
}
